<template>
  <div>
    <el-dialog :visible.sync="dialogSetVisible" title="选择冲借销的产品序列号" @close="closeDialog" @open="openDialog">
      <div class="search-content">
        <div class="search-input">
          <span>冲借销借用单号:</span>
          <el-input v-model="searchText" placeholder="查询冲借销借用单号" style="margin-bottom:15px;margin-right:10px;width:30%" clearable />
          <span>产品型号:</span>
          <el-input v-model="productName" placeholder="查询产品型号" style="margin-bottom: 15px;margin-right:10px;width:30%" clearable /><br>
          <span>冲借销序列号:</span>
          <el-input v-model="sn" placeholder="查询冲借销序列号" style="margin-bottom: 15px;width:30%" clearable />
        </div>
        <!-- <div class="search-input">
          <span>产品型号:</span>
          <el-input v-model="searchText" placeholder="查询产品型号" style="margin-bottom: 15px" clearable />
        </div> -->
        <!-- <div class="search-input">
          <span>冲借销序列号:</span>
          <el-input v-model="searchText" placeholder="查询冲借销序列号" style="margin-bottom: 15px" clearable />
        </div> -->
        <div class="search-btn">
          <el-button type="primary" style="margin-bottom: 15px" @click="onSearch()">
            搜索
          </el-button>
        </div>
      </div>
      <el-button type="primary" style="margin-bottom: 15px" @click="addProduct">
        选择勾选的产品
      </el-button>
      <div v-loading="tableLoading" class="tableBody">
        <el-table ref="multipleTable" :data="tableData" border style="width: 100%" @selection-change="handleSelectionChangeAppend">
          <el-table-column type="selection" width="55" />
          <!-- <el-table-column type="index" width="60" label="选择" align="left"> -->
          <!-- <template slot-scope="scope">
              <span>{{ (page.currentPage - 1) * page.pageSize + scope.$index + 1 }}</span>
            </template> -->
          <!-- <template v-slot="{row,$index}"> -->
          <!-- <el-button type="text" style="padding: 0;" @click="copyRow(row,$index)"> <i class="el-icon-circle-plus-outline" style="font-size: 16px;" /> </el-button> -->
          <!-- <el-button type="text" @click="removeProduct($index)" style="padding: 0;color: #F56C6C"> <i class="el-icon-delete" style="font-size: 16px;" /> </el-button> -->
          <!-- </template> -->
          <!-- </el-table-column> -->
          <el-table-column prop="shipProductCode" label="销售产品代码" align="left" />
          <el-table-column prop="shipProductName" label="产品型号" align="left" />
          <el-table-column prop="debitNum" label="冲借销借用单号" align="left" />
          <el-table-column prop="shipMaterialNumberId" label="冲借销物料编号" align="left" />
          <el-table-column prop="shipSnCode" label="冲借销序列号" align="left" />
          <!-- <el-table-column label="操作" align="left">
            <template v-slot="{row}">
              <el-button type="text" @click="editOrderPerson(row)">编辑</el-button>
              <el-button type="text" @click="deleteOrderPerson(row)">删除</el-button>
            </template>
          </el-table-column> -->
        </el-table>
        <div style="text-align: right;margin-top: 10px">
          <el-pagination
            :page-sizes="[10, 20, 30, 40]"
            :page-size.sync="page.pageSize"
            :current-page.sync="page.currentPage"
            layout="total, prev, pager, next, jumper,sizes"
            :total="page.total"
            hide-on-single-page
            @size-change="handerSizeChange"
            @current-change="handerCurrentChange"
          />
        </div>
        <div class="search-content" style="padding:10px 0 ">
          <div class="search-input">
            <span>已选择{{ tableDataDel.length }}个序列号</span>
          </div>
        </div>
        <el-button type="primary" style="margin-bottom: 15px" @click="removeProduct">
          删除勾选的产品
        </el-button>
        <el-table ref="multipleTable" :data="tableDataDel" border style="width: 100%" @selection-change="handleSelectionChangeDel">
          <el-table-column type="selection" width="55" />
          <el-table-column prop="shipProductCode" label="销售产品代码" align="left" />
          <el-table-column prop="shipProductName" label="产品型号" align="left" />
          <el-table-column prop="debitNum" label="冲借销借用单号" align="left" />
          <el-table-column prop="shipMaterialNumberId" label="冲借销物料编号" align="left" />
          <el-table-column prop="shipSnCode" label="冲借销序列号" align="left" />
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogSetVisible = false">取 消</el-button>
        <el-button type="primary" :loading="tableLoading" @click="sureSet">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { returnProduct, saveProductBorrowToSell, selectBorrowToSellListByContractId } from '@/API';
export default {
  data () {
    return {
      dialogSetVisible: false,
      searchText: '',
      productName: '',
      sn: '',
      tableLoading: false,
      tableData: [], // 接口数据
      tableDataDel: [], // 本地存储数据
      multipleSelectionAppend: [],
      multipleSelectionDel: [],
      getData: {
        contractId: '',
        contractProductInfoList: []
      },
      page: {
        pageSize: 10,
        total: 0,
        currentPage: 1
      }
    };
  },
  methods: {
    closeDialog () {
      // 清空dialog内容
      this.tableDataDel = [];
      this.tableData = [];
      this.searchText = '';
      this.$emit('setSerialClose', false);
    },
    openDialog () {
      // this.initData();
      selectBorrowToSellListByContractId({
        'contractId': this.getData.contractId,
        'pageIndex': 1,
        'pageSize': 100
      }).then((res) => {
        if (res.data.status === '200') {
          this.tableDataDel = res.data.data.list;
        }
      }).catch((err) => {
        console.log(err);
      });
    },
    handerSizeChange (val) {
      this.page.pageSize = val;
      this.initData();
    },
    handerCurrentChange (val) {
      this.page.currentPage = val;
      this.initData();
    },
    sureSet () {
      // if (this.tableDataDel.length < 1) {
      //   return this.$notify.error({
      //     message: '请选择需要设置的产品'
      //   });
      // }
      saveProductBorrowToSell({
        ...this.getData,
        'reversalReturnDTOList': this.tableDataDel
      }).then((res) => {
        if (res.data.status === '200') {
          // 添加emit 回传成功字段 刷新表格 关闭窗口
          this.$emit('getTableData', res.data.data);
          this.closeDialog();
        }
      }).catch((err) => {
        console.log(err);
      });
    },
    onSearch () {
      this.tableLoading = true;
      let parmas = {
        'debitNumber': this.searchText,
        'productName': this.productName,
        'sn': this.sn,
        'pageSize': this.page.pageSize,
        'pageNum': this.page.currentPage
      };
      returnProduct(parmas).then((res) => {
        this.page.total = res.data.data.total;
        this.tableData = res.data.data.list;
        this.tableLoading = false;
      }).catch((err) => {
        console.log(err);
        this.tableLoading = false;
      });
    },
    initData () {
      this.onSearch();
    },
    // 获取单行和index
    // copyRow (row, index) {
    //   console.log(row, index);
    //   this.tableDataDel.push(row);
    // },
    handleSelectionChangeAppend (val) {
      this.multipleSelectionAppend = val;
    },
    handleSelectionChangeDel (val) {
      this.multipleSelectionDel = val;
    },
    addProduct () {
      // 只赋值给下面表格,注意去重
      if (this.multipleSelectionAppend.length !== 0) {
        this.tableDataDel = this.tableDataDel.concat(this.multipleSelectionAppend);
        this.tableDataDel = this.deWeight(this.tableDataDel, 'shipSnCode');
      } else {
        this.$notify.error({
          message: '请选择需要添加的产品'
        });
      }
    },
    removeProduct () {
      if (this.multipleSelectionDel.length !== 0) {
        for (let i = 0; i < this.tableDataDel.length; i++) {
          for (let k = 0; k < this.multipleSelectionDel.length; k++) {
            if (this.tableDataDel[i].shipSnCode === this.multipleSelectionDel[k].shipSnCode) {
              this.tableDataDel.splice(i, 1);
            }
          }
        };
      } else {
        this.$notify.error({
          message: '请选择需要删除的产品'
        });
      }
    },
    // 数组中对象去重方法
    deWeight (arr, key) {
      var result = [];
      var obj = {};
      for (var i = 0; i < arr.length; i++) {
        if (!obj[arr[i][key]]) {
          result.push(arr[i]);
          obj[arr[i][key]] = true;
        }
      }
      return result;
    }
  },
  props: {
    dialogvisible: {
      type: Boolean,
      default: () => {
        return false;
      }
    },
    setSerialData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  watch: {
    dialogvisible (val) {
      this.dialogSetVisible = val;
    },
    setSerialData (val) {
      // console.log(val, 'this is val');
      this.getData.contractProductInfoList = val.getGoodsList;
      this.getData.contractId = val.contractId;
    }
  }
};
</script>
<style lang="scss" scoped>
.search-content{
    display: flex;
    .search-btn{
      margin-left: 20px;
      width: 56px;
      margin-top: 30px;
      // flex-grow: 1;
    }
    .search-input{
      flex-grow: 1;
      width: 0;
      .el-input{
          margin-left: 10px;
          width: 70%;
      }
    }
  }
</style>
